import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  listInsuranceRequests,
  resetListInsuranceRequests,
} from '../../features/insuranceRequests/insuranceRequestsActions';
import Pagination from '../../common/components/elements/Pagination';
import ErrorComponent from '../../common/components/ErrorComponent';
import {
  getQuotationStatus,
  purchaseUrls,
  urls,
  getProductIcon,
  quotations_filter_statues,
  is_renewal,
} from '../../common/constants';
import {
  RequestListPageStyles,
  PageHeader,
  SearchButton,
  EmptyState,
  LoadingState,
  RequestsList,
} from './RequestListPage.styles';
import { FormInputSelect } from '../../common/formInputs/FormInputSelect';
import {
  BrokerListItemCard,
  BrokerListItemHeader,
  BrokerListItemContent,
  BrokerListItemSection,
  BrokerListItemLabel,
  BrokerListItemValue,
  BrokerListItemStatusBadge,
  BrokerListItemRenewalBadge,
  BrokerListItemAction,
  BrokerListItemFilterCard,
} from '../../common/components/BrokerListItem.styles';

function RequestListPage() {
  const state = useSelector(
    (store) => store.insuranceRequests.insurance_requests_list,
  );

  const {
    loading, insurance_requests, page_number, total_pages, error,
  } = state;

  const [search, setSearch] = useState({
    customer_name: '',
    vehicle_plate: '',
    date_from: '',
    date_to: '',
    quotation_status: 'all',
    is_renewal: 'all',
  });

  const getItemLink = (insurance_request) => (
    <Link
      to={`${insurance_request.request_status === 1
        ? urls[insurance_request.product_slug]
        : purchaseUrls[insurance_request.is_offline === 1 ? 'offline_quote' : insurance_request.product_slug]
      }${insurance_request.request_token}`}
    >
      <BrokerListItemAction>
        Vai al preventivo →
      </BrokerListItemAction>
    </Link>
  );

  const searchHandler = (e) => {
    e.preventDefault();

    const trimmedSearch = {
      ...search,
      customer_name: search.customer_name.trim(),
      vehicle_plate: search.vehicle_plate.trim(),
    };

    listInsuranceRequests(1, trimmedSearch);
  };

  const handleChange = ({ target: { value, name } }) => {
    setSearch({ ...search, [name]: value });
  };

  useEffect(() => () => {
    resetListInsuranceRequests();
  }, []);

  return error === null ? (
    <RequestListPageStyles>
      <div className="container-fluid">
        <PageHeader>
          <h2>Preventivi</h2>
        </PageHeader>

        <BrokerListItemFilterCard className="not-saved-quotations-three mb-4">
          <form onSubmit={searchHandler}>
            <div className="row align-items-end mb-3">
              <div className="col-md-4">
                <label
                  htmlFor="customer_name"
                  className="form-label small mb-1"
                  style={{ marginTop: '8px' }}
                >
                  Contraente
                </label>
                <input
                  type="text"
                  name="customer_name"
                  id="customer_name"
                  className="form-control form-control-sm"
                  value={search.customer_name}
                  onChange={handleChange}
                  placeholder="Nome, cognome..."
                />
              </div>

              <div className="col-md-4">
                <label
                  htmlFor="vehicle_plate"
                  className="form-label small mb-1"
                  style={{ marginTop: '8px' }}
                >
                  Targa
                </label>
                <input
                  type="text"
                  name="vehicle_plate"
                  id="vehicle_plate"
                  className="form-control form-control-sm"
                  value={search.vehicle_plate}
                  onChange={handleChange}
                  placeholder="Targa..."
                />
              </div>

              <div className="col-md-4">
                <label htmlFor="quotation_status" className="form-label small mb-1">
                  Stato Preventivo
                </label>
                <FormInputSelect
                  placeholder="Tutti"
                  options={quotations_filter_statues.filter((status) => ![6, 7].includes(status.id))}
                  value={search.quotation_status}
                  onChange={(value) => handleChange({ target: { value, name: 'quotation_status' } })}
                  customStyle="form-control-sm text-start fw-normal"
                />
              </div>
            </div>

            <div
              className="d-flex flex-wrap align-items-end mb-3"
              style={{ gap: '8px', justifyContent: 'flex-start' }}
            >

              <div className="col-12 col-md-3">
                <label htmlFor="is_renewal" className="form-label small mb-1">
                  Rinnovo
                </label>
                <FormInputSelect
                  placeholder="Tutti"
                  options={is_renewal}
                  value={search.is_renewal}
                  onChange={(value) => handleChange({ target: { value, name: 'is_renewal' } })}
                  customStyle="form-control-sm text-start fw-normal"
                />
              </div>
              <div className="col-12 col-md-3">
                <label htmlFor="date_from" className="form-label small mb-1">
                  Data da
                </label>
                <input
                  type="date"
                  name="date_from"
                  id="date_from"
                  onChange={handleChange}
                  value={search.date_from}
                  className="form-control form-control-sm"
                  lang="it-IT"
                />
              </div>

              <div className="col-12 col-md-3">
                <label htmlFor="date_to" className="form-label small mb-1">
                  Data al
                </label>
                <input
                  type="date"
                  name="date_to"
                  id="date_to"
                  className="form-control form-control-sm"
                  onChange={handleChange}
                  value={search.date_to}
                  min={search.date_from}
                  lang="it-IT"
                />
              </div>
            </div>

            <div className="d-flex gap-2" style={{ justifyContent: 'flex-start' }}>
              <SearchButton type="submit" style={{ padding: '8px 24px', fontSize: '14px', width: 'auto' }}>
                Cerca
              </SearchButton>
              <SearchButton
                type="button"
                style={{
                  background: '#6c757d',
                  borderColor: '#6c757d',
                  padding: '8px 24px',
                  fontSize: '14px',
                  width: 'auto',
                }}
                onClick={() => {
                  const emptyFilters = {
                    customer_name: '',
                    vehicle_plate: '',
                    date_from: '',
                    date_to: '',
                    quotation_status: 'all',
                    is_renewal: 'all',
                  };
                  setSearch(emptyFilters);
                  resetListInsuranceRequests();
                }}
              >
                Pulisci Filtri
              </SearchButton>
            </div>
          </form>
        </BrokerListItemFilterCard>

        <div className="row">
          <div className="col-12">
            {loading ? (
              <LoadingState className="not-saved-quotations-one">
                <div className="spinner-border" role="status" />
                <span>Caricamento preventivi in corso...</span>
              </LoadingState>
            ) : (
              <>
                <RequestsList className="not-saved-quotations-one">
                  {insurance_requests.length > 0 ? (
                    insurance_requests.map((insurance_request, index) => (
                      <BrokerListItemCard
                        key={index}
                        className="not-saved-quotations-two"
                      >
                        <BrokerListItemHeader>
                          <div className="d-flex align-items-center gap-3">
                            <div
                              style={{
                                lineHeight: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              <FontAwesomeIcon
                                icon={getProductIcon(insurance_request.product_id)}
                                style={{
                                  fontSize: '1.5rem',
                                  color: 'white',
                                }}
                              />
                            </div>
                            <div className="flex-grow-1">
                              <div>
                                <h4>
                                  PREVENTIVO
                                  {' '}
                                  {insurance_request.product_name.toUpperCase()}
                                  {' '}
                                  -
                                  {' '}
                                  {insurance_request.customer_business_name
                                    ? insurance_request.customer_business_name.toUpperCase()
                                    : `${insurance_request.customer_name?.toUpperCase()} ${insurance_request.customer_surname?.toUpperCase()}`}
                                </h4>
                                <p>
                                  {insurance_request.is_renewal ? 'Rinnovo generato il' : 'Nuovo preventivo calcolato il'}
                                  {' '}
                                  {new Date(insurance_request.created_at).toLocaleDateString('it-IT', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                  })}
                                  {' '}
                                  da sistema
                                </p>
                              </div>
                            </div>
                            {insurance_request.is_renewal ? (
                              <BrokerListItemRenewalBadge>
                                <span aria-hidden="true">↻</span>
                                Rinnovo
                              </BrokerListItemRenewalBadge>
                            ) : null}
                          </div>
                        </BrokerListItemHeader>

                        <BrokerListItemContent>
                          <div className="row">
                            <div className="col-md-4">
                              <BrokerListItemSection>
                                <BrokerListItemLabel>Contraente</BrokerListItemLabel>
                                <BrokerListItemValue>
                                  {insurance_request.customer_business_name
                                    ? insurance_request.customer_business_name
                                    : `${insurance_request.customer_name} ${insurance_request.customer_surname}`}
                                </BrokerListItemValue>
                              </BrokerListItemSection>

                              <BrokerListItemSection>
                                <BrokerListItemLabel>Prodotto</BrokerListItemLabel>
                                <BrokerListItemValue>{insurance_request.product_name}</BrokerListItemValue>
                              </BrokerListItemSection>

                              {insurance_request.company_name && (
                                <BrokerListItemSection>
                                  <BrokerListItemLabel>Compagnia</BrokerListItemLabel>
                                  <BrokerListItemValue>{insurance_request.company_name}</BrokerListItemValue>
                                </BrokerListItemSection>
                              )}

                              {(insurance_request.vehicle_plate || insurance_request.moto_plate) && (
                                <BrokerListItemSection>
                                  <BrokerListItemLabel>Targa</BrokerListItemLabel>
                                  <BrokerListItemValue>
                                    {insurance_request.vehicle_plate || insurance_request.moto_plate}
                                  </BrokerListItemValue>
                                </BrokerListItemSection>
                              )}

                              <BrokerListItemSection>
                                <BrokerListItemLabel>Decorrenza</BrokerListItemLabel>
                                <BrokerListItemValue>
                                  {new Date(insurance_request.policy_effective_date).toLocaleDateString('it-IT', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                  })}
                                </BrokerListItemValue>
                              </BrokerListItemSection>
                            </div>

                            <div className="col-md-4">
                              <BrokerListItemSection>
                                <BrokerListItemLabel>Garanzie incluse</BrokerListItemLabel>
                                <BrokerListItemValue>
                                  {insurance_request.guarantees && insurance_request.guarantees.length > 0 ? (
                                    <div className="d-flex flex-column" style={{ gap: '0.4rem' }}>
                                      {insurance_request.guarantees.map((guarantee, guaranteeIndex) => (
                                        <div key={guaranteeIndex} style={{ fontSize: '0.85rem' }}>
                                          {guarantee.name}
                                          {guarantee.price && guarantee.price !== 0 ? (
                                            <>
                                              :
                                              {' '}
                                              €
                                              {' '}
                                              {guarantee.price.toLocaleString('it-IT', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })}
                                            </>
                                          ) : ''}
                                        </div>
                                      ))}

                                      {Number(insurance_request.processing_quotation_brokerage_amount || 0) !== 0 && (
                                        <div style={{ fontSize: '0.85rem' }}>
                                          Brokeraggio:
                                          {' '}
                                          €
                                          {' '}
                                          {Number(insurance_request.processing_quotation_brokerage_amount).toLocaleString('it-IT', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })}
                                        </div>
                                      )}

                                      {insurance_request.extra_services && (
                                        <div style={{ fontSize: '0.85rem' }}>
                                          {insurance_request.extra_services[0].service_name}
                                          :
                                          {' '}
                                          €
                                          {' '}
                                          {Number(insurance_request.extra_services[0].total_price).toLocaleString('it-IT', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })}
                                        </div>
                                      )}

                                      <div
                                        style={{
                                          fontSize: '0.95rem',
                                          marginTop: '0.5rem',
                                          paddingTop: '0.5rem',
                                          borderTop: '1px solid #e8e8e8',
                                        }}
                                      >
                                        Totale:
                                        {' '}
                                        <span
                                          style={{
                                            fontSize: '1.1rem',
                                            fontWeight: '900',
                                            color: '#00a651',
                                          }}
                                        >
                                          €
                                          {' '}
                                          {(
                                            insurance_request.guarantees.reduce(
                                              (sum, g) => sum + Number(g.price || 0),
                                              0,
                                            )
                                            + Number(insurance_request.processing_quotation_brokerage_amount || 0) + (insurance_request.extra_services && Number(insurance_request.extra_services[0].total_price))
                                          ).toLocaleString('it-IT', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })}
                                        </span>
                                      </div>
                                      {insurance_request.payment_frequency === 2 && (
                                        <div
                                          style={{
                                            marginTop: '0.75rem',
                                            paddingTop: '0.75rem',
                                            borderTop: '2px solid #e8e8e8',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '0.4rem',
                                          }}
                                        >
                                          {insurance_request.guarantees.map((guarantee, guaranteeIndex) => (
                                            <div key={guaranteeIndex} style={{ fontSize: '0.85rem' }}>
                                              {guarantee.name}
                                              {guarantee.price && guarantee.price !== 0 ? (
                                                <>
                                                  :
                                                  {' '}
                                                  €
                                                  {' '}
                                                  {(Number(guarantee.price) / 2).toLocaleString('it-IT', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                  })}
                                                </>
                                              ) : ''}
                                            </div>
                                          ))}
                                          {Number(insurance_request.processing_quotation_brokerage_amount || 0) !== 0 && (
                                            <div style={{ fontSize: '0.85rem' }}>
                                              Brokeraggio:
                                              {' '}
                                              €
                                              {' '}
                                              {(Number(insurance_request.processing_quotation_brokerage_amount) / 2).toLocaleString('it-IT', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })}
                                            </div>
                                          )}
                                          {insurance_request.extra_services && (
                                            <div style={{ fontSize: '0.85rem' }}>
                                              {insurance_request.extra_services[0].service_name}
                                              :
                                              {' '}
                                              €
                                              {' '}
                                              {Number(insurance_request.extra_services[0].added_at_installment === 2 ? insurance_request.extra_services[0].total_price : insurance_request.extra_services[0].total_price / insurance_request.payment_frequency).toLocaleString('it-IT', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })}
                                            </div>
                                          )}
                                          <div
                                            style={{
                                              fontSize: '0.95rem',
                                              marginTop: '0.5rem',
                                              paddingTop: '0.5rem',
                                              borderTop: '1px solid #e8e8e8',
                                            }}
                                          >
                                            Semestrale:
                                            {' '}
                                            <span
                                              style={{
                                                fontSize: '1.1rem',
                                                fontWeight: '900',
                                                color: '#00a651',
                                              }}
                                            >
                                              €
                                              {' '}
                                              {(
                                                (
                                                  insurance_request.guarantees.reduce(
                                                    (sum, g) => sum + Number(g.price || 0),
                                                    0,
                                                  )
                                                  + Number(insurance_request.processing_quotation_brokerage_amount || 0)
                                                ) / 2 + (insurance_request.extra_services && insurance_request.extra_services[0] ? Number(insurance_request.extra_services[0].added_at_installment === 2 ? insurance_request.extra_services[0].total_price : insurance_request.extra_services[0].total_price / insurance_request.payment_frequency) : 0)
                                              ).toLocaleString('it-IT', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  ) : insurance_request.processing_quotation_id ? (
                                    <div style={{ fontSize: '0.85rem', color: '#666', fontStyle: 'italic' }}>
                                      In elaborazione...
                                    </div>
                                  ) : (
                                    <div style={{ color: '#888', fontSize: '0.85rem', fontStyle: 'italic' }}>
                                      Nessuna garanzia selezionata
                                    </div>
                                  )}
                                </BrokerListItemValue>
                              </BrokerListItemSection>
                            </div>

                            <div className="col-md-4 d-flex flex-column">
                              <div className="d-flex justify-content-end mb-3">
                                <BrokerListItemStatusBadge
                                  variant={
                                    insurance_request.cauzioni_status === 'refused'
                                      ? 'ko'
                                      // eslint-disable-next-line eqeqeq
                                      : insurance_request.processing_quotation_status == 9
                                        ? 'ko'
                                        : insurance_request.processing_quotation_status
                                          ? 'processing'
                                          : insurance_request.cauzioni_status === 'accepted'
                                            ? 'processing'
                                            : 'new'
                                  }
                                >
                                  {insurance_request.cauzioni_status === 'refused'
                                    ? 'Rifiutata'
                                    : insurance_request.cauzioni_status === 'accepted' && !insurance_request.processing_quotation_status
                                      ? 'Accettata'
                                      : insurance_request.processing_quotation_status
                                        ? getQuotationStatus(insurance_request.processing_quotation_status)
                                        : 'Nuovo'}
                                </BrokerListItemStatusBadge>
                              </div>

                              <div className="mt-auto d-flex justify-content-end">
                                {getItemLink(insurance_request)}
                              </div>
                            </div>
                          </div>
                        </BrokerListItemContent>
                      </BrokerListItemCard>
                    ))
                  ) : (
                    <EmptyState className="not-saved-quotations-no-result">
                      <div className="empty-icon">📭</div>
                      <h5>Trova con facilità i preventivi che cerchi</h5>
                      <p>
                        Utilizza i filtri per trovare un preventivo o clicca su &quot;Cerca&quot; per visualizzare gli ultimi calcolati
                      </p>
                    </EmptyState>
                  )}
                </RequestsList>

                <div className="mt-4">
                  <Pagination
                    total_pages={total_pages}
                    current_page={page_number}
                    onClick={listInsuranceRequests}
                    search={search}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </RequestListPageStyles>
  ) : (
    <ErrorComponent error={error} />
  );
}

export default RequestListPage;
